const ChooseProjectInstance = new (function () {
  const customStripeModal = $('.custom-stripe-modal')
  const mainContainer = $('.choose-project')

  const self = this
  self._company_id = null
  self._is_trial = false
  self._scroll_box = null
  self._acive_project = ''

  self.setActiveProject = function (url) {
    self._acive_project = url
  }

  self.getActiveProject = function () {
    return self._acive_project
  }

  self.renderProject = function () {
    // if not trial...
    if (self._is_trial) {
      // console.log('already trial or paid company', self._acive_project)
      window.location.href = self._acive_project
      // window.reload()
      return
    }

    const modalTitle = i18next.t('choose-project.start-trial-period')
    const modalMessage = i18next.t('choose-project.start-your-30-days-trial-period')
    const modalData = {
      name: i18next.t('choose-project.start-trial-period'),
      class: 'btn-primary-success',
      url: '/company/' + self._company_id + '/admin/trial',
      post_data: {
        trial: true,
        plugin: 'trial',
      },
    }

    const modalItems = { kayboard: false, modal_class: 'small-confirm', close_btn_name: i18next.t('common.no') }

    const handleConfirm = (status, result) => {
      if (status === 'ok') {
        // go to the project page
        mainContainer.find('.status-msg').append(`<div class="success"><div>${i18next.t('common.done')}</div></div>`)
        customStripeModal.modal('hide')
        window.location.href = '/company/' + self._company_id + '/admin#configuration'
      }
      // show error
      // console.log('there is an error', result)
      return
    }

    confirmDialog(customStripeModal, modalTitle, modalMessage, modalData, modalItems, handleConfirm)
  }

  self._initScrollBox = function () {
    self._scroll_box = new SimpleBar($('.projects')[0], {
      autoHide: false,
      scrollbarMinSize: 3,
    })
  }

  self.init = function (params) {
    const { company_id, is_already_trial } = params
    // console.log('is_already_trial', is_already_trial)
    self._company_id = company_id
    self._is_trial = is_already_trial

    self._initScrollBox()

    // if the selected project is already exist
    // scroll down to that item.
    const hasActiveProject = $('.projects span.active').length > 0

    if (hasActiveProject) {
      const elements = self._scroll_box.getScrollElement()

      const activeItemScrollTop = $('.projects span.active').position().top

      $(elements).animate({ scrollTop: activeItemScrollTop }, 500)

      self.setActiveProject($('.projects span.active').attr('href'))
    }
  }
})()

$(function () {
  // Hit Enter to confirm the selection — same target as the visible button.
  $(document).on('keyup', function (e) {
    if (e.which === 13 && $('.btn-project.next').length) {
      $('.btn-project.next').trigger('click')
    }
  })

  // Select a project — delegated so it keeps working after SimpleBar
  // restructures `.projects` into its own wrapper at init().
  $(document).on('click', '.projects .project-option', function (e) {
    e.preventDefault()
    $('.projects .project-option').removeClass('active')
    $(this).addClass('active')
    ChooseProjectInstance.setActiveProject($(this).attr('href'))
  })

  // "Commencer" — always re-read the active project straight from the DOM so
  // we cannot end up with a stale empty `_acive_project` (which used to make
  // the button silently do nothing). Falls back to the first project if none
  // is selected.
  $(document).on('click', '.btn-project.next', function (e) {
    e.preventDefault()

    var $active = $('.projects .project-option.active')
    if (!$active.length) {
      $active = $('.projects .project-option').first()
      $active.addClass('active')
    }

    var url = $active.attr('href')
    if (!url) return

    ChooseProjectInstance.setActiveProject(url)
    ChooseProjectInstance.renderProject()
  })
})
